import React, { Fragment, useState } from 'react';
import lowerWave from '../assets/icons/background/lower-wave-2.svg';
import upperWave from '../assets/icons/background/upper-wave-2.svg';
import Heading from '../UI/Heading';
import PortfolioCard from '../UI/PortfolioCard';
import ShineonPng from '../assets/images/portfolio/shienon.png';
import Smarking from '../assets/images/portfolio/smarking.jpg';
import weddingSpot from '../assets/images/portfolio/weddingspot.png';
import Prosapient from '../assets/images/portfolio/prosapient.png';
import Tufin from '../assets/images/portfolio/tufin.png';
import ProcessMaker from '../assets/images/portfolio/ProcessMaker.jpg';
import Smartsheet from '../assets/images/portfolio/smartsheet.png';
import Avaya from '../assets/images/portfolio/Avaya.jpg';
import Eksperience from '../assets/images/portfolio/eksperience.png';
import BostonSolar from '../assets/images/portfolio/boston-solar.png';
import Link from '../UI/Link';
import data from '../data/portfolio.json';

export default function Portfolio() {
  const [openTab, setOpenTab] = useState('web');

  return (
    <Fragment>
      <section className='text-gray-400 bg-gray-900 body-font border-b border-gray-700 pt-8'>
        <Heading h1={'MY PROJECTS'} h2={data.heading} animation={'fade-up'} />

        <div className='container px-5 py-12 mx-auto' data-aos='fade-in'>
          <br />

          {/* <PortfolioCard
            name={'proSapient'}
            desc={
              'proSapient is a company that provides primary research and expert networking services to institutional investors, consultants, and corporate clients globally. \n ❖ Led the development team in creating a global deployment for a product with a complex process, focusing on clear and easy-to-perceive visual solutions. \n ❖ Collaborated with the largest customers of the client to provide customized development and deployment services. \n ❖ Reviewed the software architecture and infrastructure to ensure a robust and reliable design.'
            }
            tech={'react, redux, next, typescript, css, tailwindcss, graphql'}
            githubURL={''}
            webURL={'https://goschoolbox.com/'}
            gif={''}
            image={Prosapient}
            platform={'web'}
            openTab={openTab}
          /> */}
          <PortfolioCard
            name={'Smarking'}
            desc={
              'Developed incremental loading to optimize performance and boost rendering speed of homepage by 306%. \n Built core product features(i.e. occupancy alerts, an oversell analysis tool, and a revenue goal tracker) using React, Redux, Redux-saga, and related libraries and tools. \n Implemented responsive layouts with Twitter Bootstrap framework for seamless layouts on desktops, tablets and smartphones.\n Worked on a small, fast-paced, agile engineering team using tools such as Git, Jira, and Docker. '
            }
            tech={'react, redux, node, chartjs, typescript, sass, materialui, graphql, jest, docker'}
            githubURL={''}
            webURL={'https://smarking.com/'}
            gif={''}
            image={Smarking}
            platform={'web'}
            openTab={openTab}
          />

          <PortfolioCard
            name={'Boston Solar'}
            desc={
              '• On the backend, I worked with Python, Django REST Framework, Celery, and Pandas, focusing on complex calculations for solar panel system capacity. Integrations with PVWatts® for calculation support and DocuSign for electronic agreements streamlined the entire process. \n The frontend was crafted using React and Next.js, with Redux and Redux Toolkit enhancing state management. A particular emphasis was placed on building performant forms with React Hook Form, ensuring a responsive and intuitive user experience. \n The project prioritized collaboration, from initial scoping sessions to continuous feedback loops with the client. We devised user story maps, identified key challenges, and planned the most effective strategies for a successful MVP.'
            }
            tech={'react, next,  typescript, redux, python, django, postgres, tailwindcss, aws'}
            githubURL={''}
            webURL={'https://www.bostonsolar.us/'}
            gif={''}
            image={BostonSolar}
            platform={'web'}
            openTab={openTab}
          />
          <PortfolioCard
            name={'prosapient'}
            desc={
              'Utilized ReactJS, Next.js, Redux, GraphQL, and CSS Modules for front-end development. \n Led the development team in creating a global deployment for a product with a complex process, focusing on clear and easy-to-perceive visual solutions. \n Collaborated with the largest customers of the client to provide customized development and deployment services. \n Reviewed the software architecture and infrastructure to ensure a robust and reliable design.'
            }
            tech={'next, react, redux, typescript, graphql, apollo, mongodb, docker'}
            githubURL={''}
            webURL={'https://www.prosapient.com/ '}
            gif={''}
            image={Prosapient}
            platform={'web'}
            openTab={openTab}
          />

          <PortfolioCard
            name={'Eksperience'}
            desc={
              "Developed a dynamic mobile application using React Native and TypeScript, connecting fans with their favorite celebrities in novel ways. \n Used MongoDB and Firebase for reliable data management and integrated Express.js in a Node.js environment for efficient backend operations. \n Implemented interactive features, such as personalized autographs, gaming sessions, live video chats, and a unique item shop, employing Docker and Kubernetes for containerization and orchestration."
            }
            tech={'reactnative, react, typescript, sass, materialui, firebase, xcode'}
            githubURL={''}
            webURL={'https://eksperience.net/'}
            gif={''}
            image={Eksperience}
            platform={'web'}
            openTab={openTab}
          />

          <PortfolioCard
            name={'Avaya'}
            desc={
              'Developed a single page application with powerful features using Angular 14, Typescript, and RXJS, backed by a Node.js and Express server for efficient and scalable handling of HTTP requests. \n Utilized Angular CLI extensively to create components, services, pipes, and directives, keeping up with the latest features of Angular 14. \n Implemented routing functionality using the Angular router module for seamless navigation within the application, while using Node.js and Express for server-side route handling. \n Employed lazy loading techniques to optimize performance, reducing initial payload and download time, further enhanced by efficient server-side operations managed by Node.js and Express.'
            }
            tech={'angular, typescript, node, express, materialui, tailwindcss, aws, elasticsearch'}
            githubURL={''}
            webURL={'https://avaya.com'}
            gif={''}
            image={Avaya}
            platform={'web'}
            openTab={openTab}
          />
          <PortfolioCard
            name={'ProcessMaker'}
            desc={
              'Utilized the Laravel and PHP for backend development, implementing the Model-View-Controller (MVC) pattern and Object-Oriented Programming (OOP) principles, which led to efficient and maintainable code.\n Collaborated with a team of developers in an Agile/Scrum environment, using Vue.js, Nuxt.js, and TypeScript alongside JavaScript, AJAX, JSON, jQuery, HTML5, and CSS for front-end work. Our collaboration was critical in identifying and resolving bugs, which were reported in Jira tickets or detected through automated tests.\n Enhanced the performance of backend code by optimizing queries and reducing duplicate calls to the MySQL database using DBeaver.\n Employed PHPUnit for the development and maintenance of automated tests, covering HTTP status code assertions and database assertions, thus ensuring comprehensive test coverage and adapting to system changes.'
            }
            tech={'vue, nuxt, typescript, php, laravel, mysql, aws'}
            githubURL={''}
            webURL={'https://www.processmaker.com/'}
            gif={''}
            image={ProcessMaker}
            platform={'web'}
            openTab={openTab}
          />
          <PortfolioCard
            name={'Tufin'}
            desc={
              'Utilized Python and Django to design and implement network security orchestration software solutions, adhering to microservices architecture and SOLID principles, while employing Test-Driven Development for code reliability. \n Developed a dynamic frontend using Angular, TypeScript, and Tailwind CSS, along with creating Python scripts for integration with the product API and various customer server environments. \n Managed Postgres database connections, ensured data integrity, and leveraged AWS and Elasticsearch for robust cloud infrastructure and improved data analytics capabilities.'
            }
            tech={'python, django, postgres, angular, typescript, tailwindcss, aws'}
            githubURL={''}
            webURL={'https://www.tufin.com/'}
            gif={''}
            image={Tufin}
            platform={'web'}
            openTab={openTab}
          />
        </div>
      </section>
    </Fragment>
  );
}
